<script>
  export { className as class }
  export let type = "neutral"

  export let paddingSize = "default"

  const Types = {
    neutral: "card--neutral [ bg-neutral-100 border border-neutral-200 ]",
    beige: "bg-beige-50 border-beige-50",
    none: "",
  }

  const PaddingSizes = {
    default: "py-6 px-8",
    none: "",
  }

  let className = ""
</script>

<div class="{className} card {Types[type]} {PaddingSizes[paddingSize]}">
  <slot />
</div>
